export default function(src) {
  return `https://files.wds.fm/admin/${src}.png`;
}



// WEBPACK FOOTER //
// ./src/util/img.js